import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

/**
 * Image component is used to display images.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/image#usage)
 * - [Props](https://blockparty.endpoint.com/components/image#props)
 * <br />
 *
 */
const Image = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    src,
    alt,
    dataTestId = 'image',
    fallbackSrc,
    ...rest
  } = _ref;
  const url = src || fallbackSrc || 'https://via.placeholder.com/150';
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    alt: alt,
    as: "img",
    "data-test-id": dataTestId,
    role: "img",
    src: url,
    width: "100%"
  }, rest));
});

export { Image };
